const escrowWalletIT = {
    "view": {
        "title": "Gestisci il tuo Portafoglio Escrow",
        "descriptionParagraph1": "I fondi sono trattenuti per garantire sicurezza e trasparenza durante il processo di verifica. Per i brani segnalati, una commissione di <strong>15 €</strong> per brano è trattenuta in escrow per inserire il brano nella whitelist per la consegna a Spotify. Questi fondi saranno rimborsati una volta che gli artisti del brano saranno verificati come legittimi.",
        "descriptionParagraph2": "Utilizza la tabella sottostante per visualizzare tutte le transazioni escrow. Per ulteriori dettagli, <1><strong>Scopri di più</strong></1>",
        "label": {
            "totalWithheld": "Totale Trattenuto",
            "totalRefunds": "Totale Rimborsi"
        },
        "escrowPayments": {
            "title": "Pagamenti Escrow",
            "table": {
                "column": {
                    "paymentId": "ID Pagamento",
                    "releaseName": "Rilascio",
                    "amount": "Importo",
                    "paymentDate": "Data Pagamento",
                    "paymentAgreement": "Accordo di Pagamento",
                    "refundProcessed": "Rimborso Elaborato",
                    "requestRefund": "Richiedi Rimborso",
                    "details": "Dettagli"
                },
                "placeholder": {
                    "search": "Cerca..."
                },
                "button": {
                    "download": "Scarica",
                    "exportCsv": "Esporta CSV",
                    "view": "Visualizza",
                    "requestRefund": "Richiedi Rimborso"
                },
                "label": {
                    "notAvailable": "Non Disponibile"
                },
                "modal": {
                    "requestRefund": {
                        "header": "Richiedi Rimborso",
                        "body": {
                            "description": "Sei sicuro di voler richiedere un rimborso per questo pagamento?",
                            "note": "Si prega di notare che questa richiesta è soggetta a revisione da parte dell'amministratore e, se approvata, verrà aggiunta come dichiarazione per la quale è possibile emettere una fattura."
                        },
                        "button": {
                            "confirm": "Conferma",
                            "cancel": "Annulla"
                        },
                        "message": {
                            "success": "Richiesta di Rimborso inviata con successo!",
                            "error": "Qualcosa è andato storto, riprova più tardi!"
                        }
                    }
                }
            }
        },
        "escrowPaymentBreakdown": {
            "title": "Dettaglio Pagamenti Escrow",
            "table": {
                "column": {
                    "paymentId": "ID Pagamento",
                    "trackName": "Brano",
                    "amount": "Importo",
                    "paymentDate": "Data Pagamento"
                }
            }
        },
        "escrowRefunds": {
            "title": "Rimborsi Escrow",
            "table": {
                "column": {
                    "refundId": "ID Rimborso",
                    "paymentId": "ID Pagamento",
                    "release": "Rilascio",
                    "amount": "Importo",
                    "requestDate": "Data Richiesta",
                    "status": "Stato"
                },
                "label": {
                    "pending": "In Attesa",
                    "approved": "Approvato",
                    "rejected": "Respinto"
                },
                "tooltip": {
                    "pending": "La tua richiesta di rimborso è attualmente in attesa di revisione da parte dell'amministratore e sarà elaborata a breve.",
                    "approved": "La tua richiesta di rimborso è stata approvata e una dichiarazione è stata aggiunta per l'importo del rimborso.",
                    "rejected": "La tua richiesta di rimborso è stata respinta dall'amministratore, puoi richiedere nuovamente il rimborso."
                },
                "placeholder": {
                    "search": "Cerca..."
                },
                "button": {
                    "exportCsv": "Esporta CSV"
                }
            }
        }
    },
    "transactionSuccess": {
        "view": {
            "title": "Transazione Riuscita :)",
            "description": "Il pagamento Escrow è stato completato con successo, il rilascio pertinente sarà inserito nella whitelist a breve!",
            "button": {
                "returnToDashboard": "Torna alla Dashboard"
            }
        }
    },
    "transactionFailure": {
        "view": {
            "title": "Transazione Annullata :(",
            "description": "La transazione è stata annullata... Riprova più tardi!",
            "button": {
                "returnToDashboard": "Torna alla Dashboard"
            }
        }
    }
};

export default escrowWalletIT;